// extracted by mini-css-extract-plugin
module.exports = {"loading":"Geofence_loading__1t9dD","form":"Geofence_form__36IdM","name":"Geofence_name__2l6We","hr":"Geofence_hr__E9zwQ","toggle":"Geofence_toggle__TMaQw"};